import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { Product } from 'src/app/models/app.models';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common.service';
import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { ProductService } from 'src/app/services/product.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'calsoft-new-product-carousel',
  templateUrl: './new-product-carousel.component.html',
  styleUrls: ['./new-product-carousel.component.scss']
})
export class NewProductCarouselComponent  implements OnInit,AfterViewInit, OnDestroy, OnChanges {

  @Input() categoryId: any;
  @Input() header: any;
  @Input() id: any;
  @Input() productImageHeight: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() data: any;
  @Input() showConfigurableDropdown: any;
  @Input() urlNavigation: any = true;
  @Input() preloadCount: number = 2; // default number of slides to preload
  @Input() lowEnd: boolean = false;
  @Input() heightMobile: any;
  @Input() widthMobile: any;
  @Input() sortOrder: any;
  @Input() other: any;
  @Input() type: any = "home";
  @Input() height: any;
  @Input() width: any;
  @Input() imageType: any;
  @Input() item: any;
  @Input() slidesPerView: any;
  @Input() hideTitle: any = false;
  @Input() productLayoutType: any;
  categoryProducts: any = [];
  count: any;
  isEmpty: any;
  pageSize: any;
  public page: any = 0;
  size: number = 10;
  sortParam: any;
   public showArrows: boolean = false;
  countryCode: string;
  url: string;
  isReady: boolean = false;
  effectiveLowEnd: boolean = false;

  categoryId5: any = 0;
  categoryId4: any = 0;
  customField27: any;
  customField28: any;
  customField29: any;
  @Input() border: any = 0;

  @Input() gap: any = 0;

  @Input() displayTitle: any = 0;
  mobileShow: number = 2;
  isDealOver: boolean = false;
  date: Date;
  showTimer: boolean;

    // public settings: Settings;
  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private currencyConversionService: CurrencyConversionService,
    private productService: ProductService,
    private userService: UserService,
    private cartServices: CartService,
    private router: Router,
    private ngZone: NgZone, private cdr: ChangeDetectorRef
  ) {

  }
  productLayoutEnable: any = 0;

  gapLayout: any = 0;

ngOnInit(): void {

        // For mobile or low-end devices, reduce page size to avoid heavy initial loads
    try {
      const isMobile = (typeof window !== 'undefined') && window.innerWidth <= 768;
      if (isMobile || this.effectiveLowEnd) {
        this.size = 5;
      }
    } catch (e) {
      // ignore in non-browser environments
    }

    // Defensive: Ensure data exists and is an object
    if (this.data && typeof this.data === 'object') {
      if (window.innerWidth > 1279) {
        if (this.data.productWebGap != null && this.data.productWebGap !== '' && !isNaN(parseInt(this.data.productWebGap))) {
          this.gapLayout = parseInt(this.data.productWebGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      } else if (window.innerWidth > 768 && window.innerWidth <= 1279) {
        if (this.data.tabWebGap != null && this.data.tabWebGap !== '' && !isNaN(parseInt(this.data.tabWebGap))) {
          this.gapLayout = parseInt(this.data.tabWebGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      } else {
        if (this.data.productMobileGap != null && this.data.productMobileGap !== '' && !isNaN(parseInt(this.data.productMobileGap))) {
          this.gapLayout = parseInt(this.data.productMobileGap.replace('px', ''));
        } else {
          this.gapLayout = 0;
        }
      }
    } else {
      this.gapLayout = 0;
    }


    this.mobileShow = 2;
    this.slidesPerView = 4;
    if (this.item && typeof this.item === 'object') {
      if (this.item.customField30 !== undefined && this.item.customField30 !== null && this.item.customField30 > 0) {
        this.mobileShow = this.item.customField30;
        this.mobileCount = this.item.customField30;
      }
      if (this.item.customField29 !== undefined && this.item.customField29 !== null && this.item.customField29 > 0) {
        this.slidesPerView = this.item.customField29;
         this.desktopCount = this.item.customField29;
      }
    }



    this.url = this.router.url;

    if (this.type != 'product') {
      this.productsByCategory();
    } else {
      this.productsByList();
    }

    // Defensive: Ensure gapLayout, slidesPerView, mobileShow are always valid numbers
    if (isNaN(this.gapLayout) || this.gapLayout == null) this.gapLayout = 0;
    if (isNaN(this.slidesPerView) || this.slidesPerView == null) this.slidesPerView = 4;
    if (isNaN(this.mobileShow) || this.mobileShow == null) this.mobileShow = 2;

    if (this.productLayoutType == 17) {

      this.productLayoutEnable = 1

    } else {

      this.productLayoutEnable = 0;

    }


    if (this.item != null && typeof this.item === 'object') {
      if (this.categoryId4 != undefined && this.item.categoryId4 !== undefined) {
        this.categoryId4 = this.item.categoryId4;
      }

      if (this.categoryId5 != undefined && this.item.categoryId5 !== undefined) {
        this.categoryId5 = this.item.categoryId5;
      }

      if (this.item.customField27 != null && this.item.customField27 !== '') {
        try {
          document.documentElement.style.setProperty('--custom-width', this.item.customField27);
        } catch (e) {
          console.warn('Could not set --custom-width:', e);
        }
        this.customField27 = this.item.customField27;
      }

      if (this.item.customField28 != null && this.item.customField28 !== '') {
        try {
          document.documentElement.style.setProperty('--custom-width-mob', this.item.customField28);
        } catch (e) {
          console.warn('Could not set --custom-width-mob:', e);
        }
        this.customField28 = this.item.customField28;
      }

      if ((this.item?.customField31 !== undefined

        && this.item?.customField31 !== "") && this.item?.customField33 !== undefined

        && this.item?.customField33 !== "") {

        let utcDateStr = this.item?.customField31; // e.g., '2025-07-22T18:30:00.000Z'
        let timeStr = this.item?.customField33; // e.g., 'HH:mm'

        // Step 1: Convert UTC to IST string
        let istString = new Date(utcDateStr).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });

        // Step 2: Convert string back to Date object
        let istBaseDate = new Date(istString);

        // Step 3: Set time from customField33
        let hours = 0, minutes = 0;

        if (typeof timeStr === 'string' && timeStr.includes(':')) {
          [hours, minutes] = timeStr.split(':').map(Number);
        }
        istBaseDate.setHours(hours);
        istBaseDate.setMinutes(minutes);
        istBaseDate.setSeconds(0); // Optional: reset seconds


        const now = new Date();
        let nowIST = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        // Step 4: You now have final IST date with time


        let diffMillis = istBaseDate.getTime() - nowIST.getTime(); // Positive if future, negative if past

        // Convert to useful units
        let diffMinutes = Math.floor(diffMillis / (1000 * 60));
        let diffHours = Math.floor(diffMillis / (1000 * 60 * 60));
        let diffDays = Math.floor(diffMillis / (1000 * 60 * 60 * 24));
        let diffSeconds = Math.floor(diffMillis / 1000);


        if (isNaN(diffSeconds)) {

          diffSeconds = 0;
          this.isDealOver = true;

          this.showTimer = false;
        }


        if (diffSeconds) {
          this.countdownTarget = istBaseDate;
          this.date = istBaseDate;
          this.showTimer = true;
          this.startCountdown(); // start the timer
        }



      }
    } else {
      this.categoryId4 = this.border;
      this.categoryId5 = this.displayTitle;
    }

    let countryCode = this.currencyConversionService.getCountryCode();
    if (countryCode == null) {
      this.countryCode = "INR";
    }
    else {
      this.countryCode = countryCode;
    }

    // compute effective low-end: prefer explicit input, otherwise auto-detect
    this.effectiveLowEnd = !!this.lowEnd || this.isAutoDetectLowEnd();

    // if effectiveLowEnd is true, tune defaults conservatively so carousels
    // don't do heavy image preloads or show many slides on weak devices
    if (this.effectiveLowEnd) {
      this.preloadCount = Math.max(1, Math.floor(this.preloadCount / 2));
      this.slidesPerView = Math.min(this.slidesPerView || 3, 3);
      this.mobileShow = Math.min(this.mobileShow || 2, 2);
      try {
        // add a global class so global CSS can reduce animations/filters
        if (typeof document !== 'undefined' && document && document.body) {
          document.body.classList.add('low-end-device');
        }
      } catch (e) {
        // ignore in environments without DOM
      }
    }



    this.getCustomerCount();
  // Compute visible count early (before view init) so bindings like `isMobile`
  // are stable during the first change detection pass. This prevents
  // ExpressionChangedAfterItHasBeenCheckedError when values are toggled in
  // ngAfterViewInit.
  try { this.computeVisibleCount(); } catch (e) {}

  // Start with not-ready; we'll mark ready after data + config are set
  this.isReady = false;

  }

  public productsByCategory() {

    if (this.other == 'category') {
      this.categoryId = this.commonService.getEncryptedId(parseInt(this.id))
      this.productService.productsByCategoryIdx(decodeURIComponent(this.categoryId), this.page, this.size, this.sortOrder).subscribe(
        res => {
          if (res != null) {
              this.categoryProducts = res['content'];
              this.count = res['totalElements'];
              this.isEmpty = res['empty'];
              this.pageSize = res['totalPages'];
            } else {
              this.categoryProducts = [];
              this.count = 0;
              this.isEmpty = true;
              this.pageSize = 0;
            }
            // Only show arrows once we have slides
            this.showArrows = Array.isArray(this.categoryProducts) && this.categoryProducts.length > 0;
        }

      )
    } else {

      let methodName = "getProductBySearch";
      let search = ''
      if (this.other == 'productScope') {
        methodName = "getProductByCustomProductId";
        search = this.id
      } else {

        let value = 1;
        search = "isInStock:" + '*' + value + '*'
          + "' AND featured:" + '*' + value + '*' + "' "
      }


      this.productService[methodName](search, this.page, this.size, this.sortOrder).subscribe(
        res => {
          this.categoryProducts = res['content'];
          this.count = res['totalElements'];
          this.isEmpty = res['empty'];
          this.pageSize = res['totalPages']
        })
    }
  }


  // trackBy for product *ngFor
  trackByProduct(index: number, item: any) {
    // Prefer stable unique id if available
    return item && (item.entityId || item.id || item.sku) ? (item.entityId || item.id || item.sku) : index;
  }


  goToCategory() {
    if (this.other == 'productScope') {
      this.commonService.productSearch(this.id)
    } else {
      this.commonService.goToCategory(1, parseInt(this.id));
    }
  }
  values: any = "*values*";
  getCustomerCount() {

    let authourized = this.userService.getAuthenticatedUser();
    if (authourized) {


      this.cartServices.geWishListProduct();

      this.cartServices.getCustomerCartProductCount().subscribe(
        (response) => {


          this.values = response;

          let value = localStorage.getItem(Constant.CART_COUNT);
          if (value == null) {
            let encryptedValue = btoa(JSON.stringify(response));

            this.userService.storeProductCartCount(encryptedValue);
          }
        },
        (err) => { }
      );
    }
  }


  totalHoursFromAdmin: any; // Set this value from admin input
  private countdownTarget!: Date;
  private timer!: any;

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;


  startCountdown() {
    this.timer = setInterval(() => {
      const now = new Date().getTime();


      const distance = this.countdownTarget.getTime() - now;

      if (distance <= 0) {
        this.days = this.hours = this.minutes = this.seconds = 0;
        this.isDealOver = true;
        clearInterval(this.timer);
        this.showTimer = false;

        // 💾 Mark as finished
        localStorage.setItem('countdownFinished', 'true');
        localStorage.removeItem('countdownTarget');
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

    }, 1000);
  }



  // Heuristic to detect low-end devices. Keep this conservative and fast.
  isAutoDetectLowEnd(): boolean {
    try {
      if (typeof navigator === 'undefined') return false;
      // Prefer explicit hints where available
      const ua = (navigator && navigator.userAgent) ? navigator.userAgent.toLowerCase() : '';

      // Quick checks
      // - Very low hardware concurrency (1 or 2 logical cores)
      // - Low deviceMemory (<= 2GB) where supported
      const hc = (navigator as any).hardwareConcurrency || 4;
      const dm = (navigator as any).deviceMemory || 4;

      if (hc <= 2 || dm <= 2) return true;

      // Older Android WebViews / phones often contain 'android' and not 'chrome'
      if (ua.includes('android') && (ua.includes('mobile') || !ua.includes('chrome'))) return true;

      return false;
    } catch (e) {
      return false;
    }
  }

   @Input('products') products: Array<Product> = [];

  productsByList() {
    this.categoryProducts = this.products;
    this.showArrows = Array.isArray(this.categoryProducts) && this.categoryProducts.length > 0;
  }


 @ViewChild('viewportRef', { read: ElementRef, static: true }) viewportRef!: ElementRef<HTMLElement>;

  // listeners bound for removal
  private _boundTouchStart = (e: TouchEvent) => this._onTouchStart(e);
  private _boundTouchMove = (e: TouchEvent) => this._onTouchMove(e);
  private _boundTouchEnd = (e: TouchEvent) => this._onTouchEnd(e);

  // directional lock state
  private _touchLock: 'none' | 'horizontal' | 'vertical' = 'none';
  private _touchStartX = 0;
  private _touchStartY = 0;

   @Input() desktopCount: number = 5;
  @Input() mobileCount: number = 2;
  @Input() showArrowsOnMobile: boolean = false; // allow arrows on mobile when true
  isMobile: boolean = false;
  // coerce boolean-like inputs (also supports attribute presence like autoplay="")
  private _autoplay: boolean = false;
  @Input()
  set autoplay(v: any) {
    this._autoplay = (v === '' || !!v);
    try { console.debug && console.debug('Carousel: autoplay input set ->', v, 'coerced ->', this._autoplay); } catch {}
    // restart/stop autoplay immediately when input changes
    if (this._autoplay) this.startAutoplay(); else this.stopAutoplay();
  }
  get autoplay(): boolean { return this._autoplay; }
  @Input() autoplayInterval: number = 1000; // ms (default lowered for faster testing)
  @Input() loop: boolean = false;
  @Input() showDots: boolean = false;
  @Input() pauseOnHover: boolean = false;
  // autoplayStep: 'page' advances by visibleCount (default), 'item' advances by a single item
  @Input() autoplayStep: 'page' | 'item' = 'page';
  // autoplayMode controls behavior when reaching the ends:
  // 'forward' -> advance forward and stop at end (unless loop=true),
  // 'loop' -> wrap to start when reaching end,
  // 'alternate' -> ping-pong back and forth,
  // 'backward' -> always move backward.
  @Input() autoplayMode: 'forward' | 'loop' | 'alternate' | 'backward' = 'alternate';

  // internal direction for 'alternate' mode: 1 == forward, -1 == backward
  private _autoplayDir: 1 | -1 = 1;

  currentIndex: number = 0;
  visibleCount: number = 1; // computed from desktop/mobile counts

  // Dragging state
  private dragStartX: number | null = null;
  private dragOffset: number = 0; // px
  private pointerId: number | null = null;
  private resizeObserver: any;
  private autoplayTimer: any = null;
  private isInteracting: boolean = false;

  get visibleProducts() {
    return this.products.slice(this.currentIndex, this.currentIndex + this.visibleCount);
  }

  get pagesCount() {
    return Math.max(1, Math.ceil(this.categoryProducts.length / this.visibleCount));
  }

  get pages() {
    return Array.from({ length: this.pagesCount }, (_, i) => i);
  }

  get currentPageIndex() {
    // compute the page that contains the currently visible items.
    // Use a formula that places currentIndex= maxIndex (partial last page) on the last page.
    const pages = this.pagesCount;
    if (this.visibleCount <= 0) return 0;
    const idx = Math.floor((this.currentIndex + this.visibleCount - 1) / this.visibleCount);
    return Math.min(Math.max(0, idx), pages - 1);
  }

  // centralize index updates so change detection and any side-effects are consistent
  private updateIndex(newIndex: number) {
    this.currentIndex = Math.max(0, Math.min(newIndex, Math.max(0, this.categoryProducts.length - this.visibleCount)));
    try { this.cdr.detectChanges(); } catch {}
  }

  goToPage(idx: number) {
    const newIndex = Math.min(Math.max(0, idx * this.visibleCount),
     Math.max(0, this.categoryProducts.length - this.visibleCount));
    this.updateIndex(newIndex);
    this.resumeAfterInteraction();
  }

  get trackTransform() {
    const percentPerItem = 100 / this.visibleCount;
    const base = -this.currentIndex * percentPerItem;
    // dragOffset is in px; convert to percent of viewport width
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) || 1;
    const dragPercent = (this.dragOffset / vw) * 100;
    return `translateX(${base + dragPercent}%)`;
  }

  moveLeft() {
    if (this.currentIndex > 0) {
      const step = this.visibleCount || 1;
      this.updateIndex(Math.max(0, this.currentIndex - step));
    }
  }

  moveRight() {
    const maxIndex = Math.max(0, this.categoryProducts.length - this.visibleCount);
    if (this.currentIndex < maxIndex) {
      const step = this.visibleCount || 1;
      this.updateIndex(Math.min(maxIndex, this.currentIndex + step));
    }
  }

  // Optional: swipe support for touch devices
  onSwipeLeft() {
    this.moveRight();
  }

  onSwipeRight() {
    this.moveLeft();
  }

  // --- Basic pointer/touch swipe detection ---
  private pointerDownX: number | null = null;
  private pointerDownAt: number | null = null;
  private readonly SWIPE_THRESHOLD = 40; // pixels

  // For mouse/touch pointer start
  onPointerDown(evt: PointerEvent) {
    // start drag
    this.pointerId = evt.pointerId;
    this.dragStartX = evt.clientX;
    this.dragOffset = 0;
    (evt.target as Element).setPointerCapture?.(evt.pointerId);
  }
  onPointerMove(evt: PointerEvent) {
    if (this.dragStartX == null) return;
    // only track the active pointer
    if (this.pointerId !== null && evt.pointerId !== this.pointerId) return;
    this.dragOffset = evt.clientX - (this.dragStartX ?? 0);
  }

  onPointerUp(evt: PointerEvent) {
    if (this.dragStartX == null) return;
    const dx = this.dragOffset;
    const threshold = Math.max(40, (window.innerWidth || 320) * 0.08); // 8% of width or 40px
    if (dx <= -threshold) this.moveRight();
    else if (dx >= threshold) this.moveLeft();

    this.dragStartX = null;
    this.dragOffset = 0;
    try { (evt.target as Element).releasePointerCapture?.(evt.pointerId); } catch {}
    this.pointerId = null;
    try { this.cdr.detectChanges(); } catch {}
  }

  // Touch event fallbacks for older browsers
  onTouchStart(evt: TouchEvent) {
    const t = evt.touches[0];
    if (!t) return;
    // create a synthetic pointer-like event
    this.onPointerDown({ clientX: t.clientX, pointerId: 1 } as any as PointerEvent);
  }

  onTouchMove(evt: TouchEvent) {
    const t = evt.touches[0];
    if (!t) return;
    this.onPointerMove({ clientX: t.clientX, pointerId: 1 } as any as PointerEvent);
  }

  onTouchEnd(evt: TouchEvent) {
    // create a synthetic pointerup
    this.onPointerUp({ clientX: this.dragStartX ?? 0, pointerId: 1 } as any as PointerEvent);
  }

  // Private non-passive handlers used when we attach listeners directly
  private _onTouchStart(evt: TouchEvent) {
    const t = evt.touches && evt.touches[0];
    if (!t) return;
    this._touchStartX = t.clientX;
    this._touchStartY = t.clientY;
    this._touchLock = 'none';
    // reuse pointer start logic
    this.onPointerDown({ clientX: t.clientX, pointerId: 1 } as any as PointerEvent);
  }

  private _onTouchMove(evt: TouchEvent) {
    const t = evt.touches && evt.touches[0];
    if (!t) return;
    if (this._touchLock === 'none') {
      const dx = Math.abs(t.clientX - this._touchStartX);
      const dy = Math.abs(t.clientY - this._touchStartY);
      // small threshold to decide intent
      if (dx > 5 || dy > 5) {
        this._touchLock = dx > dy ? 'horizontal' : 'vertical';
      }
    }
    // if horizontal drag detected, prevent vertical scrolling
    if (this._touchLock === 'horizontal') {
      try { evt.preventDefault(); } catch {}
    }
    // forward to pointer move logic
    this.onPointerMove({ clientX: t.clientX, pointerId: 1 } as any as PointerEvent);
  }

  private _onTouchEnd(evt: TouchEvent) {
    // end of interaction
    this._touchLock = 'none';
    // forward to pointer up
    this.onPointerUp({ clientX: this.dragStartX ?? 0, pointerId: 1 } as any as PointerEvent);
  }

  // Also listen to keyboard arrows for accessibility
  @HostListener('keydown', ['$event'])
  handleKey(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.moveLeft();
    if (event.key === 'ArrowRight') this.moveRight();
  }

  @HostListener('window:resize')
  onResize() {
    this.computeVisibleCount();
  }

  private computeVisibleCount() {
    const w = (typeof window !== 'undefined') ? window.innerWidth : 1024;
    const prev = this.visibleCount;

    // Breakpoint mapping (mirrors swiper / responsive breakpoints):
    // 0..480 -> use mobileCount/mobileShow
    // 481..740 -> 3 slidesPerView
    // 741..960 -> 3 slidesPerView
    // >960 -> desktopCount
    if (w <= 480) {
      this.visibleCount = this.mobileCount || this.mobileShow || 1;
      this.isMobile = true;
    } else if (w <= 740) {
      this.visibleCount = 3;
      this.isMobile = false;
    } else if (w <= 960) {
      this.visibleCount = 3;
      this.isMobile = false;
    } else {
      this.visibleCount = this.desktopCount || this.slidesPerView || 1;
      this.isMobile = false;
    }

    // ensure index bounds (defensive: categoryProducts may be undefined)
    const productsCount = Array.isArray(this.categoryProducts) ? this.categoryProducts.length : 0;
    if (this.currentIndex > Math.max(0, productsCount - this.visibleCount)) {
      this.currentIndex = Math.max(0, productsCount - this.visibleCount);
    }

    // If visible count changed, restart autoplay to re-evaluate whether it should run
    if (this.autoplay && prev !== this.visibleCount) {
      this.stopAutoplay();
      this.startAutoplay();
      try { this.cdr.detectChanges(); } catch {}
    }
  }

  ngAfterViewInit(): void {
    // optional: observe resize in case host size changes
    try {
      this.resizeObserver = new (window as any).ResizeObserver(() => this.computeVisibleCount());
      this.resizeObserver.observe(document.documentElement);
    } catch {}
    if (this.autoplay) this.startAutoplay();
    // attach non-passive touch listeners to enable preventDefault during horizontal drags
    try {
      const el = this.viewportRef?.nativeElement as HTMLElement | null;
      if (el && el.addEventListener) {
        el.addEventListener('touchstart', this._boundTouchStart, { passive: false });
        el.addEventListener('touchmove', this._boundTouchMove, { passive: false });
        el.addEventListener('touchend', this._boundTouchEnd, { passive: false });
      }
    } catch {}
    // Defer a change-detection check to avoid ExpressionChangedAfterItHasBeenCheckedError
    // caused by values (like visibleCount/isMobile) mutating during initialization.
    try {
      setTimeout(() => { try { this.cdr.detectChanges(); } catch (e) {} }, 0);
    } catch (e) {}
  }

  ngOnDestroy(): void {
    try { this.resizeObserver?.disconnect(); } catch {}
    this.stopAutoplay();
    // remove touch listeners
    try {
      const el = this.viewportRef?.nativeElement as HTMLElement | null;
      if (el && el.removeEventListener) {
        el.removeEventListener('touchstart', this._boundTouchStart as EventListener);
        el.removeEventListener('touchmove', this._boundTouchMove as EventListener);
        el.removeEventListener('touchend', this._boundTouchEnd as EventListener);
      }
    } catch {}
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If autoplay input changed, start/stop the timer appropriately
    if (changes['autoplay'] && !changes['autoplay'].isFirstChange()) {
      if (this.autoplay) this.startAutoplay(); else this.stopAutoplay();
    }

    // If visible counts or products length changed, recompute and clamp currentIndex
    if (changes['desktopCount'] || changes['mobileCount'] || changes['products']) {
      this.computeVisibleCount();
    }
  }

  private startAutoplay() {
    // guard: don't start if already running or no need to advance
    if (this.autoplayTimer) return;
    if (!this.autoplay) return;
    const productsCount = Array.isArray(this.categoryProducts) ? this.categoryProducts.length : 0;
    if (productsCount <= (this.visibleCount || 0) && !this.loop) return;

    try { console.debug && console.debug('Carousel: startAutoplay requested', { autoplay: this.autoplay, products: productsCount, visibleCount: this.visibleCount, loop: this.loop }); } catch {}
    this.stopAutoplay();
    // run interval outside to avoid Angular zone leaks, but run UI updates inside zone
    this.autoplayTimer = setInterval(() => {
      if (!this.isInteracting) {
        this.ngZone.run(() => {
          // compute step: either a page (visibleCount) or single item
          const step = this.autoplayStep === 'item' ? 1 : (this.visibleCount || 1);
          const maxIndex = Math.max(0, this.categoryProducts.length - this.visibleCount);

          // determine next index depending on autoplayMode
          let nextIndex = this.currentIndex;

          if (this.autoplayMode === 'backward') {
            nextIndex = Math.max(0, this.currentIndex - step);
            try { console.debug && console.debug('Carousel: autoplay tick (backward)', 
              { currentIndex: this.currentIndex, nextIndex, maxIndex }); } catch {}
            if (nextIndex === this.currentIndex) {
              // at start, stop unless loop
              if (this.loop) this.updateIndex(maxIndex); else this.stopAutoplay();
            } else {
              this.updateIndex(nextIndex);
            }
          } else if (this.autoplayMode === 'alternate') {
            // ping-pong direction
            if (this._autoplayDir === 1) {
              nextIndex = Math.min(this.currentIndex + step, maxIndex);
              try { console.debug && console.debug('Carousel: autoplay tick (alternate forward)', { currentIndex: this.currentIndex, nextIndex, maxIndex }); } catch {}
              if (this.currentIndex >= maxIndex) {
                // switch direction
                this._autoplayDir = -1;
                if (maxIndex > 0) this.updateIndex(Math.max(0, this.currentIndex - step));
              } else {
                this.updateIndex(nextIndex);
              }
            } else {
              // moving backward
              nextIndex = Math.max(0, this.currentIndex - step);
              try { console.debug && console.debug('Carousel: autoplay tick (alternate backward)', { currentIndex: this.currentIndex, nextIndex, maxIndex }); } catch {}
              if (this.currentIndex <= 0) {
                // switch direction
                this._autoplayDir = 1;
                if (maxIndex > 0) this.updateIndex(Math.min(maxIndex, this.currentIndex + step));
              } else {
                this.updateIndex(nextIndex);
              }
            }
          } else {
            // forward or loop behavior
            nextIndex = Math.min(this.currentIndex + step, maxIndex);
            try { console.debug && console.debug('Carousel: autoplay tick (forward/loop)', { currentIndex: this.currentIndex, nextIndex, maxIndex, mode: this.autoplayMode }); } catch {}
            if (this.currentIndex < maxIndex) {
              this.updateIndex(nextIndex);
            } else if (this.autoplayMode === 'loop' || this.loop) {
              this.updateIndex(0);
            } else {
              try { console.debug && console.debug('Carousel: autoplay reached end, stopping'); } catch {}
              this.stopAutoplay();
            }
          }
        });
      }
    }, this.autoplayInterval);
  }

  private stopAutoplay() {
    if (this.autoplayTimer) { try { console.debug && console.debug('Carousel: stopAutoplay'); } catch {} clearInterval(this.autoplayTimer); this.autoplayTimer = null; }
  }

  pauseForInteraction() {
    this.isInteracting = true;
    this.stopAutoplay();
  }

  resumeAfterInteraction() {
    this.isInteracting = false;
    // only restart autoplay if autoplay is enabled and we can advance (or loop enabled)
    if (this.autoplay && (this.loop || this.currentIndex < Math.max(0, this.categoryProducts.length - this.visibleCount))) {
      this.startAutoplay();
    }
  }

  // Arrow disabled states
  get isPrevDisabled(): boolean {
    return !this.loop && this.currentIndex <= 0;
  }

  get isNextDisabled(): boolean {
    return !this.loop && this.currentIndex >= Math.max(0, this.categoryProducts.length - this.visibleCount);
  }

  // Returns true if the item at `index` should be treated as the trailing element
  // (i.e. should NOT receive a trailing gap). We consider it trailing when it is
  // either the last visible in the current viewport or the very last item in the list.
  isTrailingItem(index: number): boolean {
    const lastVisible = (this.currentIndex || 0) + (this.visibleCount || 1) - 1;
    const isLastVisible = index === lastVisible;
    const isLastOverall = Array.isArray(this.categoryProducts) && (index === this.categoryProducts.length - 1);
    // Only treat the very last overall item as trailing when we're actually on the last page.
    const onLastPage = (this.pagesCount > 0) ? (this.currentPageIndex === this.pagesCount - 1) : false;
    return isLastVisible || (isLastOverall && onLastPage);
  }

  // Returns padding-right in pixels for an item at `index`.
  // We only apply gap to items that are not trailing items.
  itemPadding(index: number): number {
    // gapLayout is expected to be an integer number of pixels
    const gapPx = Number.isFinite(Number(this.gapLayout)) ? Number(this.gapLayout) : 0;
    return this.isTrailingItem(index) ? 0 : gapPx;
  }

  // Returns the flex CSS value used for each item, accounting for gaps.
  // Exposed as a getter so the template can bind without inline string concatenation.
  get itemFlex(): string {
    const gap = Number.isFinite(Number(this.gapLayout)) ? Number(this.gapLayout) : 0;
    const vc = this.visibleCount || 1;
    const totalGaps = Math.max(0, vc - 1) * gap;
    return `0 0 calc((100% - ${totalGaps}px) / ${vc})`;
  }



}
